import { FuelFlex } from '@frete.com/fuel-station-react'
import { CheckoutFeedbackProps, FeedbackGuidelines } from './interfaces'
import { useTranslator } from '~hooks'
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react'
import * as Styled from './styled'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import FeedbackFooter from './Footer'

function CheckoutFeedback({ type = 'notAllowed', onCancel, onRetry }: CheckoutFeedbackProps) {
  const { k, t } = useTranslator()
  const feedbackGuidelines: FeedbackGuidelines = {
    notAllowed: {
      title: t(k.translation.NO_PERMISSIONS_TO_PURCHASE),
      description: t(k.translation.NO_PERMISSIONS_TO_PURCHASE_DESCRIPTION),
      icon: 'alert',
      roundedColor: theme.color.support.orange.strong,
    },
    failure: {
      title: t(k.translation.SOMETHING_WENT_WRONG),
      description: t(k.translation.SOMETHING_WENT_WRONG_DESCRIPTION),
      icon: 'close',
      roundedColor: theme.color.background.brand.default,
    },
  }

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <FuelFlex
        defaultProps={{
          flexDirection: 'column',
          width: '100%',
          gap: 'km8',
          alignItems: 'center',
          height: '100%',
          justifyContent: 'center',
          customPadding: `${theme.padding.km0} ${theme.spacing.km8}`,
        }}
      >
        <FuelFlex
          defaultProps={{
            flexDirection: 'column',
            gap: 'km4',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Styled.Rounded
            defaultProps={{
              backgroundColor: feedbackGuidelines[type].roundedColor,
            }}
          >
            <div style={{ color: `${theme.color.icon.neutral.inverted}` }}>
              <FuelIcon name={feedbackGuidelines[type].icon} size="medium" />
            </div>
          </Styled.Rounded>
          <Styled.TextsWrapper
            defaultProps={{
              gap: 'km2',
              flexDirection: 'column',
              customPadding: '0 52px',
            }}
          >
            <FuelTypography size="heading-lg" weight="bold">
              {feedbackGuidelines[type].title}
            </FuelTypography>
            <FuelTypography size="body-md" weight="regular" color="neutral-default" spacingLeft={2} spacingRight={2}>
              {feedbackGuidelines[type].description}
            </FuelTypography>
          </Styled.TextsWrapper>
        </FuelFlex>
      </FuelFlex>
      <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
        <FeedbackFooter type={type} onCancel={onCancel} onRetry={onRetry} />
      </div>
    </div>
  )
}

export default CheckoutFeedback
